.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--qs-space-24);
  min-height: var(--qs-layout-navbar-height);
  padding: 0 var(--qs-layout-gutter-desktop);
  position: relative;

  @media (max-width: 719px) {
    min-height: var(--qs-layout-navbar-height-phone);
    padding: 0 var(--qs-layout-gutter-phone);
  }
}

.wordmark {
  display: flex;
  align-items: baseline;
  gap: var(--qs-space-8);
  font-family: var(--qs-font-display);
  font-style: italic;
  font-size: var(--qs-type-wordmark-size);
  color: var(--qs-color-text);
  text-decoration: none;
  flex: none;
}

// Public ---------------------------------------------------------------------

.links {
  flex: 1;
  display: flex;
  justify-content: center;

  ul {
    display: flex;
    gap: var(--qs-space-32);
    list-style: none;
    margin: 0;
    padding: 0;
  }

  a {
    color: var(--qs-color-text-soft);
    text-decoration: none;
    font-size: var(--qs-type-label-size);

    &:hover { color: var(--qs-color-text); }
  }

  @media (max-width: 719px) {
    display: none;
  }
}

.publicActions {
  display: flex;
  align-items: center;
  gap: var(--qs-space-16);
  white-space: nowrap;
}

// Phone (Navbar board, "Public · phone"): the bar keeps Begin Session and the menu button; the
// account moves into the sheet, below a separator.
.desktopAccount {
  @media (max-width: 719px) {
    display: none;
  }
}

.sheetSeparator {
  height: 1px;
  background: var(--qs-color-line);
}

.menuToggle {
  display: none;
  align-items: center;
  justify-content: center;
  width: var(--qs-target-min);
  height: var(--qs-target-min);
  border: none;
  background: transparent;
  color: var(--qs-color-text-soft);

  @media (max-width: 719px) {
    display: inline-flex;
  }
}

.menuSheet {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  padding: var(--qs-space-16) var(--qs-layout-gutter-phone);
  gap: var(--qs-space-16);
  background: var(--qs-color-surface-raised);
  border-bottom: 1px solid var(--qs-color-line);
  z-index: 40;

  a {
    color: var(--qs-color-text-soft);
    text-decoration: none;
    font-size: var(--qs-type-body-size);
  }
}

// Session ---------------------------------------------------------------------

.session {
  transition: opacity var(--qs-motion-dur-veil) var(--qs-motion-ease-veil);

  &.receded {
    .sessionControls > *:not(.account) {
      opacity: 0.45;
    }
  }

  &.hidden {
    opacity: 0;
    pointer-events: none;
  }
}

.sessionControls {
  display: flex;
  align-items: center;
  gap: var(--qs-space-8);
}

// Account ---------------------------------------------------------------------

.account {
  position: relative;
}

.accountTrigger {
  display: grid;
  place-items: center;
  width: var(--qs-target-min);
  height: var(--qs-target-min);
  padding: 0;
  border-radius: var(--qs-radius-pill);
  border: 1px solid var(--qs-color-line);
  background: transparent;
  color: var(--qs-color-text);
  cursor: pointer;

  svg { color: var(--qs-color-accent); }

  &:hover { border-color: var(--qs-color-line-strong); }

  transition: border-color var(--qs-motion-dur-fade) var(--qs-motion-ease-settle);
}

.purchased {
  border-color: var(--qs-color-success);
}

.accountMenu {
  position: absolute;
  top: calc(100% + var(--qs-space-8));
  right: 0;
  min-width: 180px;
  padding: var(--qs-space-8);
  border-radius: var(--qs-radius-md);
  background: var(--qs-color-surface-raised);
  border: 1px solid var(--qs-color-line);
  box-shadow: var(--qs-elev-popover);
  z-index: 40;
  display: flex;
  flex-direction: column;
}

.balance {
  display: flex;
  align-items: center;
  gap: var(--qs-space-8);
  margin: 0 0 var(--qs-space-8);
  padding: var(--qs-space-8) var(--qs-space-12) var(--qs-space-12);
  border-bottom: 1px solid var(--qs-color-line);
  color: var(--qs-color-text);
  font-size: var(--qs-type-label-size);
  white-space: nowrap;

  svg { color: var(--qs-color-accent); }
}

.menuItem {
  display: flex;
  align-items: center;
  gap: var(--qs-space-8);
  width: 100%;
  min-height: var(--qs-target-min);
  padding: 0 var(--qs-space-12);
  border: none;
  background: transparent;
  border-radius: var(--qs-radius-sm);
  color: var(--qs-color-text-soft);
  font-size: var(--qs-type-body-size);
  text-decoration: none;
  cursor: pointer;
  text-align: left;

  &:hover { background: var(--qs-color-surface); color: var(--qs-color-text); }
}
